import React, {Component} from "react";
import {map} from "lodash";
import {message, Select} from "antd";
import Script from "react-load-script";

import AllState from "../../../../../Assets/data/stateList.json";
import cross_icon from "../../../../../Assets/images/cross_icon.svg";
import * as yup from "yup";
import Axios from 'axios';
const {Option} = Select;

class AddAddress extends Component {

  state = {
    is_address_manually: false,
    address: {address: '', city: '', state: '', zip_code: ''},
    is_btn_active: false
  }

  // Google Map Place API
  handleScriptLoad = () => {

    // Declare Options For Autocomplete
    const options = { componentRestrictions: { country: 'us' } };

    // Initialize Google Autocomplete
    /*global google*/ // To disable any eslint 'google not defined' errors
    const newAutoComplete = new google.maps.places.Autocomplete(
      document.getElementById('google_address'),
      options,
    );

    // Avoid paying for data that you don't need by restricting the set of
    // place fields that are returned to just the address components and formatted
    // address.
    newAutoComplete.setFields(['address_components', 'formatted_address']);

    // Fire Event when a suggested name is selected
    newAutoComplete.addListener('place_changed', this.handlePlaceSelect);

    this.setState({
      autocomplete: newAutoComplete,
    })
  };
  removeEmpty=(obj) =>{
    return Object.fromEntries(Object.entries(obj).filter(([_, v]) => (v !== null && v?.trim() !== "")));
  }
  handlePlaceSelect = () => {
    const address= document?.getElementById('google_address')?.value;
    Axios.get(`https://maps.googleapis.com/maps/api/geocode/json`, {
      params: this.removeEmpty({
        latlng: undefined,
        address,
        key: process.env.REACT_APP_GOOGLE_PLACE_API_KEY,
      })
    }).then((res) => {
      const addressObject = res?.data?.results[0];
      let obj = {};
      map(addressObject?.address_components, (item) => {

        if (item?.types?.includes('administrative_area_level_2')) {
          obj = Object.assign(obj, { 'address': item.short_name })
        }
        if (item?.types?.includes('route')) {
          obj = Object.assign(obj, { 'route': item.long_name })
        }
        if (item?.types?.includes('street_number')) {
          obj = Object.assign(obj, { 'street_number': item.short_name })
        }
        if (item?.types?.includes('administrative_area_level_1')) {
          obj = Object.assign(obj, { 'state': item.short_name })
        }
        if (item?.types?.includes('locality')) {
          obj = Object.assign(obj, { 'city': item.long_name })
        }
        if (item?.types?.includes('postal_code')) {
          obj = Object.assign(obj, { 'zip_code': item.short_name })
        }
      });
      obj.address=`${obj?.street_number || ''} ${obj?.route || ''}`;
      this.setState({ address: obj }, () => {
        if (!obj?.address || !obj?.state || !obj.city || !obj.zip_code) {
          message.error('Please enter valid address')
        }
        this.validate();
      });
    }).catch((err) => {
      console.log(err)
    })
  }

  // validate numeric input
  onNumericInputChange = (value) => {
    const reg = /^-?\d*(\.\d*)?$/;
    console.log(((!isNaN(value) && reg.test(value)) || value === '' || value === '-'))
    return ((!isNaN(value) && reg.test(value)) || value === '' || value === '-')
  };

  // on address change
  onAddressChange = (e) => {
    const {address} = this.state;
    Object.assign(address, {[e.target.name]: e.target.value})
    this.setState({address}, () => this.validate());
  };

  // card validation
  validate = () => {
    const {address} = this.state;
    setTimeout(() => {
      const schema = yup.object().shape({
        address: yup.object().shape({
          address: yup.string().required("Address is required"),
          state: yup.string().required("State is required"),
          city: yup.string().required("City is required"),
          zip_code: yup.string().required("Zipcode is required")
        }),
      })

      const data = { address };
      schema.validate(data, { abortEarly: false }).then(() => {
        this.setState({
          is_btn_active: true
        })
      }).catch(() => {
        this.setState({
          is_btn_active: false
        })
      });
    }, 500);
  }

  // render all state
  renderAllState = () => {
    return AllState.AllState.map((item, i) => {
      return (<Option value={item.abbreviation} key={i}>{item.name}</Option>)
    })
  }

  render() {
    const {is_address_manually, address, is_btn_active} = this.state;
    const {onCancel, onAdd} = this.props;

    return (
      <div>
        <div className="google_search_place mb-10">
          <Script
            url={`https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_PLACE_API_KEY}&libraries=places`}
            onLoad={() => window.requestAnimationFrame(this.handleScriptLoad)}
          />

          <input
            autoComplete="off"
            type="text"
            ref="address"
            className={is_address_manually ? 'google_search_disable form--control' : 'form--control'}
            placeholder="Search for address"
            name="google_address"
            id="google_address"
            onChange={(e) => {
              if (!e.target.value) {
                this.setState({
                  address: { address: '', state: '', city: '', zipcode: '' },
                }, () => this.validate())
              }
            }}
            disabled={is_address_manually}
          />
          <b>or <a href="/" onClick={(e) => {
            e.preventDefault();
            this.setState({
              is_address_manually: true,
              address: { address: '', state: '', city: '', zipcode: '' },
            }, () => {
              if (this.refs['address']) {
                this.refs['address'].value = '';
              }
              this.validate()})
          }}><u>enter address manually</u></a></b>

        </div>
        {
          is_address_manually &&
            <div className="manually_address">
              <a className="float-right" href="/#" onClick={(e) => {
                e.preventDefault();
                this.setState({
                  is_address_manually: false,
                  address: { address: '', state: '', city: '', zipcode: '' },
                }, () => this.validate())
              }}><img src={cross_icon} alt="" className="remove_address" /></a>
              <br />

              <div className="form-group">
                <div className="fitem">
                  <input
                    type="text"
                    placeholder="Address"
                    name="address"
                    value={address?.address}
                    onChange={(e) => this.onAddressChange(e)}
                  />
                </div>                        
                <div className="fitem">
                  <input
                    type="text"
                    className='form--control'
                    placeholder="City"
                    name="city"
                    value={address?.city}
                    onChange={(e) => this.onAddressChange(e)}
                  />
                </div>
                <div className="fitem">
                  <Select
                    showArrow={true}
                    name="state"
                    placeholder="State"
                    onChange={(value) => this.onAddressChange({ target: { name: 'state', value: value } })}
                    value={address?.state || undefined}
                    virtual={false}
                  >
                    {this.renderAllState()}
                  </Select>
                </div>

                <div className="fitem">
                  <input
                    type="text"
                    className='form--control'
                    placeholder="ZIP Code"
                    name="zip_code"
                    maxLength={5}
                    minLength={5}
                    onChange={(e) => this.onNumericInputChange(e.target.value) && this.onAddressChange(e)}
                    value={address?.zip_code || ''}
                  />
                </div>              
              </div>   
            </div>
        }
        <div className={"mt-10"}>
          <button className={'btn btn-bdr'} onClick={() => onCancel(false)}>Cancel</button>
          <button
            disabled={!is_btn_active}
            className={`btn ${is_btn_active ? 'btn-warning' : 'disabled'}`}
            onClick={() => {
              onAdd((address?.street_number && address?.route) ? {...address, address: `${address?.street_number} ${address?.route}`} : address); onCancel()
            }}
          >Add Address</button>
        </div>
      </div>
    )
  }
}

export default AddAddress